import React from "react";

import { Header, Icon } from "semantic-ui-react";

import ReimbursementLog from "../ReimbursementLog";
import ReimbursementInfoTable from "../ReimbursementInfoTable";

import _ from "lodash";

import * as moment from "moment";

const ReimbursementStatus = props => {
  const reimbursement = props.reimbursement;
  if (reimbursement.status === "submitted") {
    return (
      <span>
        <Icon name="right arrow" /> Submitted, waiting approval
      </span>
    );
  } else if (reimbursement.status === "approved") {
    return (
      <span>
        <Icon name="check" color="green" /> Approved
      </span>
    );
  } else if (reimbursement.status === "rejected") {
    return (
      <span>
        <Icon name="times" color="red" /> Rejected
      </span>
    );
  } else if (reimbursement.status === "paid") {
    return (
      <span>
        <Icon name="dollar sign" color="green" /> Paid{" "}
      </span>
    );
  }
};

const ReimbursementDisplay = props => {
  const reimbursement = props.reimbursement;
  const items = _.sortBy(
    reimbursement.change_log,
    item => -+moment(item.timestamp)
  );

  return (
    <div>
      <Header textAlign="center" size="huge" style={{ marginTop: "0.5em" }}>
        <ReimbursementStatus reimbursement={reimbursement} />
      </Header>
      <Header dividing>Information</Header>
      <ReimbursementInfoTable reimbursement={reimbursement} />
      <Header dividing>History</Header>
      <ReimbursementLog items={items} reimbursement={reimbursement} />
    </div>
  );
};

export default ReimbursementDisplay;



// WEBPACK FOOTER //
// ./frontend/src/components/unauthenticated/ReimbursementDisplay.js